import UserSearch from "./UserSearch";
import { connect } from "react-redux";
import { actions } from "./UserSearchActions";
import { withRouter } from "react-router";

export default withRouter(
  connect(
    // mapStateToProps
    state => ({
      userSearchResults: state.userSearchReducer
    }),
    // Inject all actions into the component
    actions
  )(UserSearch)
);
